import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
import { EMAIL_CAMPAIGNS_API_URL } from './url';
export async function sendCampaignEmailTest(payload) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store?.state?.auth?.tokenV3 ?? '';
    if (!brand?.id) {
        throw new Error('Brand ID não disponível');
    }
    const emailCampaignsApi = EMAIL_CAMPAIGNS_API_URL?.replace(/\/$/, '') || '';
    const base = (emailCampaignsApi || endpointVersion('v3')).replace(/\/$/, '');
    const url = `${base}/campaigns/send-email-test`;
    const res = await axios.post(url, payload, {
        params: { brand_id: brand.id },
        headers: {
            'Content-Type': 'application/json',
            ...(tokenV3 && { Authorization: `Bearer ${tokenV3}` }),
        },
        withCredentials: false,
    });
    return res.data;
}
